import incomings from './lists/Incomings'
import outgoings from './lists/Outgoings'
import euolanswers from './lists/EuolAnswers'
import inners from './lists/Inners'
import dirords from './lists/Dirords'
import ords from './lists/Ords'
import euolstatemets from './lists/EuolStatements'
import govservices from './lists/GovServices'

//#region Criterias
const innerActItemsCriterias = [
    {
        // название свойства в расширенном фильтре
        name: "ExecuterEnterpriseId",
        // тип визуального контрола
        type: 'select',
        // плейсхолдер если не выбрано / не введено  (перекочует в правый верхний угол если выбрано / введено)
        label: "Исполнитель",
        // это нужно если контрол - селект
        items: [],
        // это нужно если контрол - селект с поиском
        filteredItems: [],
        // метод для инициализации items
        init: async (store) => (await store.dispatch('references/getInnerActItemsEnterpriseExecuters')).map(i => ({ id: i.id, Value: i.name })),
        // на панели критериев всегда одинарный выбор, поэтому для адекватной работы нужно указать, как всопринимать значение свойства в расширенном фильтре (одинарное: false, множественное: true)
        isMultipleTarget: false,
    }
];
//#endregion

//#region Extended Filter Object Values (EFOV)
const incomingEFOV = {
    EFTheme: {
        label: "Краткое_содержание",
        value: null
    },
    RegNumber: {
        label: "Рег._номер",
        value: null
    },
    OutNumber: {
        label: "Исходящий_номер",
        value: null
    },
    HigherNumber: {
        label: "Номер_вышестоящего_корреспондента",
        value: null
    },
    Correspondent: {
        label: "Корреспондент",
        value: []
    },
    ExecuterName: {
        label: "Исполнитель",
        value: null
    },
    SignerName: {
        label: "Подписал",
        value: null
    },
    RegDateFrom: {
        label: "Дата_регистрации_c",
        value: null
    },
    RegDateTo: {
        label: "Дата_регистрации_по",
        value: null
    },
    Recipients: {
        label: "Получатель",
        value: []
    },
    OutDateFrom: {
        label: "Дата_исходящего_c",
        value: null
    },
    OutDateTo: {
        label: "Дата_исходящего_по",
        value: null
    },
    Language: {
        label: "Язык_документа",
        value: null
    },
    Executers: {
        label: "Исполнитель",
        value: []
    },
    ResolutionAuthor: {
        label: "Автор_резолюции",
        value: []
    },
    HasAnswer: {
        label: "Дан_ответ",
        value: null
    },
    ExecuteStatus: {
        label: "Статус_исполнения",
        value: []
    },
    IsDuplicate: {
        label: "Дубликат",
        value: null
    },
    IsIncomingAnswer: {
        label: "Входящий_ответ",
        value: null
    },
    Counter: {
        label: "Журнал_регистрации",
        value: null
    },
    NomenclatureId: {
        label: "Номенклатура",
        value: []
    },
    JuridicalDocType: {
        label: "Тип_документа",
        value: null
    },
};
const innerEFOV = {
    EFTheme: {
        label: "Краткое_содержание",
        value: null
    },
    RegNumber: {
        label: "Рег._номер",
        value: null
    },
    RegDateFrom: {
        label: "Дата_регистрации_c",
        value: null
    },
    RegDateTo: {
        label: "Дата_регистрации_по",
        value: null
    },
    Language: {
        label: "Язык_документа",
        value: null
    },
    Executers: {
        label: "Исполнитель",
        value: []
    },
    ResolutionAuthor: {
        label: "Автор_резолюции",
        value: []
    },
    Recipients: {
        label: "Получатель",
        value: []
    },
    NomenclatureId: {
        label: "Номенклатура",
        value: []
    },
    JuridicalDocType: {
        label: "Тип_документа",
        value: null
    },
    SignerEmployeeIds: {
        label: "Подписал",
        value: []
    }
};
const innerActItemsEFOV = {
    EFResolutionText: {
        label: "Краткое_содержание",
        value: null
    },
    RegNumber: {
        label: "Рег._номер",
        value: null
    },
    RegDateFrom: {
        label: "Дата_регистрации_c",
        value: null
    },
    RegDateTo: {
        label: "Дата_регистрации_по",
        value: null
    },
    ResolutionAuthor: {
        label: "Автор",
        value: []
    },
    ExecuterWorkStatus:  {
        label: "Статус",
        value: null
    },
    ExecuterEnterpriseId: {
        label: "Исполнитель",
        value: null
    }
};
const outgoingEFOV = {
    EFTheme: {
        label: "Краткое_содержание",
        value: null
    },
    RegNumber: {
        label: "Исходящий_номер",
        value: null
    },
    RegDateFrom: {
        label: "Дата_исходящего_c",
        value: null
    },
    RegDateTo: {
        label: "Дата_исходящего_по",
        value: null
    },
    Language: {
        label: "Язык_документа",
        value: null
    },
    NomenclatureId: {
        label: "Номенклатура",
        value: []
    },
    OutgoingExecuters: {
        label: "Исполнитель",
        value: []
    },
    Recipients: {
        label: "Получатель",
        value: []
    },
    SendStatus: {
        label: "Статус_отправки",
        value: null
    },
    JuridicalDocType: {
        label: "Тип_документа",
        value: null
    },
    SignerEmployeeIds: {
        label: "Подписал",
        value: []
    },
    DocumentAuthor: {
        label: "Кем_создано",
        value: []
    }
};
const statementEFOV = {
    EFAnnotation: {
        label: "Краткое_содержание",
        value: null
    },
    Declarant_IIN_BIN:
    {
        label: "ИИН_БИН",
        value: null
    },
    StQuestion:
    {
        label: "Характер_вопроса",
        value: null
    },
    PerCategory:
    {
        label: "Категория_лица",
        value: null
    },
    StLanguage:
    {
        label: "Язык_обращения",
        value: null
    },
    StForm:
    {
        label: "Форма_обращения",
        value: null
    },
    ExecuterWorkplaceId:
    {
        label: "Исполнитель",
        value: null
    },
    ControlDateFrom:
    {
        label: "Срок_исполнения_с",
        value: null
    },
    ControlDateTo:
    {
        label: "Срок_исполнения_по",
        value: null
    },
    EUOL_IsRedirected:
    {
        label: "Перенаправлено",
        value: null
    }
}
//#endregion
const getEFOV = function (source, excludeProps = []) {
    let efov = Object.assign({}, source);

    if (excludeProps.length > 0)
        excludeProps.forEach( prop => delete efov[prop] );

    return efov;
};

export default {
    namespaced: true,
    state: () => ({
        currentYear: 0,
        collection : "Incomings",
        statuses: [
            { collection: "Incomings", value: "0" },
            { collection: "Outgoings", value: "0" },
            { collection: "EuolAnswers", value: "0" },
            { collection: "Inners", value: "0" },
            { collection: "Dirords", value: "0" },
            { collection: "Ords", value: "0" },
            { collection: "IncomingActItems", value: "0" },
            { collection: "InnerActItems", value: "0" },
            { collection: "EuolStatements", value: "0" },
            { collection: "GovServices", value: "0" },
            { collection: "Contracts", value: "0" }
        ],
        searches: [
            { collection: "Incomings", value: null },
            { collection: "Outgoings", value: null },
            { collection: "EuolAnswers", value: null },
            { collection: "Inners", value: null },
            { collection: "Dirords", value: null },
            { collection: "Ords", value: null },
            { collection: "IncomingActItems", value: null },
            { collection: "InnerActItems", value: null },
            { collection: "EuolStatements", value: null },
            { collection: "GovServices", value: null },
            { collection: "Contracts", value: null }
        ],
        extendedFilters:[
            {
                collection: "Incomings",
                value: getEFOV(incomingEFOV)
            },
            {
                collection: "Dirords",
                value: getEFOV(incomingEFOV)
            },
            {
                collection: "IncomingActItems",
                value: getEFOV(incomingEFOV, [ 'IsIncomingAnswer', 'Counter' ])
            },
            {
                collection: "Outgoings",
                value: getEFOV(outgoingEFOV)
            },            
            {
                collection: "EuolAnswers",
                value: getEFOV(outgoingEFOV)
            },
            {
                collection: "Inners",
                value: getEFOV(innerEFOV, ['SignerEmployeeIds'])
            },
            {
                collection: "Ords",
                value: getEFOV(innerEFOV)
            },
            {
                collection: "InnerActItems",
                value: getEFOV(innerActItemsEFOV)
            },
            {
                collection: "EuolStatements",
                value: getEFOV(statementEFOV)
            },
            {
                collection: "GovServices",
                value: getEFOV(statementEFOV, [ 'EUOL_IsRedirected' ])
            },
        ]
    }),
    mutations: {
        SET_CURRENTYEAR (state, payload) {
            state.currentYear = payload;
        },
        SET_COLLECTION (state, payload) {
            state.collection = payload;
        },
        PUSH_STATUS (state, payload) {
            let exists = state.statuses.find(x => x.collection == payload.collection);

            if (exists)
            {
                exists.value = payload.value;
            }
            else
            {
                state.statuses.push(payload);
            }
        },
        PUSH_SEARCH (state, payload) {
            let exists = state.searches.find(x => x.collection == payload.collection);

            if (exists)
            {
                exists.value = payload.value;
            }
            else
            {
                state.searches.push(payload);
            }
        },
        PUSH_EXTENDED_FILTER (state, payload) {
            let exists = state.extendedFilters.find(x => x.collection == payload.collection);

            if (exists)
            {
                exists.value = payload.value;
            }
            else
            {
                state.extendedFilters.push(payload);
            }
        }
    },
    getters: {
        getCurrentYear: (s) => s.currentYear,
        getCollection (state) {
            return state.collection;
        },
        getStatus (state) {
            return state.statuses.find(x => x.collection === state.collection).value;
        },
        getSearch (state) {
            return state.searches.find(x => x.collection === state.collection).value;
        },
        getExtendedFilter (state) {
            return state.extendedFilters.find(x => x.collection === state.collection)?.value ?? {};
        },
        getCriterias: (s, getters) => {
            switch (s.collection)
            {
                case 'InnerActItems':
                    return getters.getStatus === "Avrora.Objects.Modules.Docflow.DocflowObjects.ActItem" ? innerActItemsCriterias : [] ;

                default:
                    return []
            }
        }
    },
    modules: {
        incomings,
        outgoings,
        euolanswers,
        inners,
        dirords,
        ords,
        euolstatemets,
        govservices
    }
}